import React from 'react';
import LessonCard from '../components/LessonCard';
import lessonsData from '../data/lessons';

const Lessons = () => (
  <div className="container">
    <h1>Lessons</h1>
    {lessonsData.map((lesson, index) => (
      <LessonCard
        key={index}
        title={lesson.title}
        description={lesson.description}
        code={lesson.code}
      />
    ))}
  </div>
);

export default Lessons;